const MSecurity = [
  {
    title: 'Security Portal',
    is_heading: true,
    is_active: false,
    link: {
      name: 'security.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-shield-check',
    active_icon: 'fad fa-shield-check'
  },
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'security.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Discipline Desk',
    is_heading: true,
    is_active: false,
    link: {
      name: 'security.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-clipboard-list',
    active_icon: 'fad fa-clipboard-list'
  },
  {
    title: 'Violation Reports',
    is_heading: false,
    is_active: false,
    link: {
      name: 'security.violations'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-exclamation-triangle',
    active_icon: 'fad fa-exclamation-triangle'
  },
  {
    title: 'Report Violation',
    is_heading: false,
    is_active: false,
    link: {
      name: 'security.violation-report'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-file-alt',
    active_icon: 'fad fa-file-alt'
  },
  {
    title: 'Account',
    is_heading: true,
    is_active: false,
    link: {
      name: 'security.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cog',
    active_icon: 'fad fa-cog'
  },
  {
    title: 'Account Settings',
    is_heading: false,
    is_active: false,
    link: {
      name: 'shared.account.settings'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-cog',
    active_icon: 'fad fa-user-cog'
  }
]

export default MSecurity
